// deps
import React, { ReactElement } from "react";
import { MANAGE_CARD_TEST_IDS } from "@swiggy-private/payment-test-ids";

// internal-deps
import { Checkbox, CHECKBOX_ACCENT, format } from "@swiggy-private/core-ui";

// styles
import styles from "../ManageCard.scss";
interface ManageCardDetailsProps {
    selected: boolean;
    cardBrandName: string;
    onClick: () => void;
    onClickKnowMore: (e: React.MouseEvent) => void;
    text?: string;
    className?: string;
}

function ManageCardSaveDetails(props: ManageCardDetailsProps): ReactElement {
    return (
        <div className={props.className}>
            {props.text && (
                <div className={styles.manageCardSaveCardDetails}>
                    <Checkbox
                        name={""}
                        accent={CHECKBOX_ACCENT.SWIGGY_ORANGE}
                        checked={props.selected}
                        onChange={props.onClick}
                    />
                    <div className={styles.manageCardSecureMessageWrapper}>
                        <div className={styles.manageCardSaveCardDetailsText}>
                            {format(props.text, props.cardBrandName)}
                        </div>
                        <div
                            data-testid={MANAGE_CARD_TEST_IDS.knowMore}
                            className={styles.manageCardSaveCardDetailsLink}
                            onClick={props.onClickKnowMore}
                        >
                            Know More
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default React.memo(ManageCardSaveDetails);
